import "bootstrap/dist/css/bootstrap.min.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "react-phone-input-2/lib/bootstrap.css";
import "react-calendar/dist/Calendar.css";
import "video-react/dist/video-react.css"; // import css
import "react-quill/dist/quill.snow.css";
import "swiper/css";
import "swiper/css/effect-cards";
import "react-circular-progressbar/dist/styles.css";
// import "animate.css/animate.min.css";
import "./asset/css/calender.css";
import "./asset/css/style.css";
import "./asset/css/feature.css";
import "./asset/css/ourteam.css";
import "./asset/css/responsive.css";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { GetRoutes, images, LazyLoadingWrapper } from "./action/customFn";
import RoutesArr from "./routes";
import { Suspense, useState } from "react";
import Loader from "./component/Loader";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { asyncGetAllTestimonials } from "./action/testimonialAction";
import { Toaster } from "react-hot-toast";
import { HelmetProvider } from "react-helmet-async";
import { asynCProfileData, resetProfileData } from "./action/profileAction";
import { asyncLogOut, setLogin, setLogout } from "./action/loginAction";
import { jwtDecode } from "jwt-decode";
import "./asset/css/NewStyle.css";
import "./asset/css/NewResponsive.css";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
import { setAllMentors } from "./action/mentorAction";
import axios from "./axios";
import "swiper/css/pagination";
import { useCookieConsent } from "./hooks/useCookieConsent";
import { loadTawk } from "./utils/loadTawk";
import { AnimatePresence, motion } from "motion/react";
import WhatsappBadge from "./component/WhatsAppBadge";



AOS.init({
  once: true
});

function App() {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { consent, accept, reject } = useCookieConsent();

  const isDashboard = location.pathname.toLowerCase().startsWith("/dashboard") || location.pathname.toLowerCase().includes("mentor-application-form");

  useEffect(() => {
    const handleStorageChange = () => {
      if (localStorage.getItem("session_expired") === "true") {
        dispatch({
          type: "SESSION_HAS_EXPIRED",
          payload: true,
        });
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  });

  useEffect(()=>{
    localStorage.removeItem("x_session-token");
  },[])

  useEffect(() => {
    dispatch(asyncGetAllTestimonials());
  }, []);

  const isLoggedIn = useSelector((state) => state.login);

  useEffect(() => {
    if (localStorage.getItem("MetBrains_token")) {
      dispatch(setLogin());
    } else {
      dispatch(setLogout());
    }
  }, []);

  useEffect(() => {
    // checkTokenExp();
    dispatch(setAllMentors([]));
  }, [pathname]);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(asynCProfileData(dispatch));
    }
  }, [isLoggedIn]);

  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowBanner(true);
    }, 5000); // 3 seconds delay (match your video loader)

    return () => clearTimeout(timer); // cleanup
  }, []);

  return (
    <div className="App">
      <HelmetProvider>
        {
          showBanner && consent === null && (
            <AnimatePresence>
              {
                <div style={{ position: "fixed", zIndex: "100", top: "0", left: "0", bottom: "0", right: "0", background: "rgba(0,0,0,0.3)" }}>
                  <motion.div initial={{ rotate: 0 }} animate={ window.screen.width < 576 ? { rotate: 25, x: "12.25vw", y:-98 } : { rotate: 25, x: "3.25vw", y:-25 }} transition={{ duration: 0.4, ease: "easeInOut" }} exit={{ rotate: 0 }} className="tour-flasher">
                    <figure><img src={images["new-tour-guy.png"]} style={{ width: "170px" }} /></figure>
                  </motion.div>
                  <motion.div className={"tour-guy-query"} initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 0.4 } }} exit={{ opacity: 0, transition: { delay: 0 } }}>
                    <div className="tail" style={{ position: "relative" }}>
                      <img style={{ position: "relative", left: '2px', width: "65px" }} src={images["tour-message-tail.svg"]} />
                    </div>
                    <div className="tour-msg-content">
                      <p>Hey!<br/> 🍪 Our site uses a small cookie to keep the chat support active while you browse. It’s functional only — no advertising, no tracking.</p>
                      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                        <button onClick={accept} className="neo-xnmrph-btn-blue" style={{background:"oklch(62.7% 0.194 149.214)"}}>Okay, got it</button>
                        <button onClick={reject} className="nothanks-btn">Reject</button>
                      </div>
                    </div>
                  </motion.div>
                </div>
              }
            </AnimatePresence>
          )
        }
        <Toaster
          toastOptions={{
            success: {
              style: {
                background: "#effbf5",
                color: "#2fba61",
                overflow: "hidden",
              },
              className: "success-toast-custom",
            },
            error: {
              style: {
                background: "#ffedec",
                color: "#fe4141",
                overflow: "hidden",
              },
              className: "error-toast-custom",
            },
          }}
          position="top-center"
          reverseOrder={false}
        />
          <Routes>
            {GetRoutes(RoutesArr)}
            </Routes>
          {!isDashboard && <WhatsappBadge />}
      </HelmetProvider>
    </div>
  );
}

export default App;
